//TODO: modify this to return the same as the old one

type Claim = {
  type: string,
  value: string
}

export type Me = {
  claims: Claim[],
  authenticated: boolean;
};

export class AuthenticatedUser {
  constructor(me : Me | null) {
    
    if (me !== null && me.claims !== null) 
    {
      this.claims = me.claims;
      
      var firstName = this.claims.find((obj) => obj.type === "given_name")?.value || "";
      var lastName = this.claims.find((obj) => obj.type === "family_name")?.value || "";
      
      this.tenantId = this.claims.find((obj) => obj.type === "tenantId")?.value || "";
      this.objectId = this.claims.find((obj) => obj.type === "objectId")?.value || "";
      
      this.fullName = firstName + " " + lastName;
      this.isLoggedIn = true;

      this.defaultRole = this.claims.find((obj) => obj.type === "default_role")?.value || "";
      this.companyId = this.claims.find((obj) => obj.type === "company_id")?.value || "";
      this.userId = this.claims.find((obj) => obj.type === "id")?.value || "";

      this.authorizedCompanies = [`${this.companyId}`]

      this.roles = this.claims.find((obj) => obj.type === "roles")?.value.split(',') || [];

      //this.authorizedCompanies = Object.keys(
      //  JSON.parse(
      //    this.claims.find((obj) => obj.type === "AuthorizedCompanies")?.value || ""
      //  )
      //);
      //this.isMSP = this.authorizedCompanies.length > 0;

      //TODO:Change
      //this.authorizedCompanies = [];
      this.isMSP = false;
      //this.userRolePermissions = [];

  } else {  
      this.tenantId = "";
      this.objectId = "";
      this.fullName = "";
      this.isLoggedIn = false;
      this.defaultRole = "";
      this.companyId = "";
      this.userId = "";
      this.authorizedCompanies = [];
      this.isMSP = false;
      this.claims = [];
      this.roles = [];
    }
  }

  public static SetDefault(): AuthenticatedUser {
    return new AuthenticatedUser(null);
  }

  private claims: Claim[];
  public roles: string[];
  public fullName: string;
  public isLoggedIn: boolean;
  public defaultRole: string;
  public companyId: string;
  public tenantId : string;
  public objectId : string;
  public userId: string;
  public authorizedCompanies: Array<string>;
  public isMSP: boolean;

  // private hasPermission(permissionName: string): boolean {
  //   if (this.claims.length === 0) return false;
  //   else return this.roles.indexOf(permissionName) !== -1;
  // }

  public canInvite() {
    //change this so it comes back as a profile or permissions object, we
    //shouldnt need the claim name here.
    return true;
    //return this.hasPermission("users.caninvite");
  }

  public isRegistered() : boolean {
    var registeredClaim = this.claims.find((c : Claim) => c.type === 'isRegistered');
    if (registeredClaim) return registeredClaim.value === 'true';
    else return false;
  }
}